import { EMAIL_PHONE_DRAFT, EMAIL_PHONE_DRAFT_SUCCESS, EMAIL_PHONE_DRAFT_ERROR, EMAIL_PHONE_DRAFT_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const EmailPhoneDraft = (state = initialState, action) => {
  switch (action.type) {
    case EMAIL_PHONE_DRAFT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case EMAIL_PHONE_DRAFT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case EMAIL_PHONE_DRAFT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case EMAIL_PHONE_DRAFT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default EmailPhoneDraft;
